"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionPortalType = void 0;
var SubscriptionPortalType;
(function (SubscriptionPortalType) {
    SubscriptionPortalType["CANCEL_SUBSCRIPTION"] = "cancel_subscription";
    SubscriptionPortalType["UPDATE_SUBSCRIPTION"] = "update_subscription";
})(SubscriptionPortalType || (exports.SubscriptionPortalType = SubscriptionPortalType = {}));
